import { render, staticRenderFns } from "./FailureSupplies.vue?vue&type=template&id=5d8cb2fc"
import script from "./FailureSupplies.vue?vue&type=script&lang=js"
export * from "./FailureSupplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports